import type IUsersRepository from '@/core/domain/users/IUsersRepository.ts'
import type { UserInput } from '@/core/domain/users/UserInput.ts'
import type { LocalUser, UserView } from '@/core/domain/users/LocalUser.ts'

export default class CreateUserUseCase {
  private readonly userRepository: IUsersRepository

  constructor(userRepository: IUsersRepository) {
    this.userRepository = userRepository
  }

  async execute(input: UserInput): Promise<LocalUser & UserView> {
    return this.userRepository.create(input)
  }
}